import * as React from "react"
import Layout from '../components/layout'
import {
	Accordion,
	AccordionHeader,
	AccordionBody,
} from "@material-tailwind/react"
import { TbPlus, TbMinus, TbChevronRight, TbArrowRight } from 'react-icons/tb';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'gatsby'
import 'swiper/css';
import 'swiper/css/navigation';
import routes from '../config/routes';
import { StaticImage } from "gatsby-plugin-image"
import { Navigation, Mousewheel } from 'swiper/modules';
import ContactForm from '../components/form'
import Plan from '../images/plan.svg';
import Deploy from '../images/deploy.svg';
import Measure from '../images/measure.svg';
import DisplayIcon from '../images/display-icon.svg';
import ChatIcon from '../images/chat-icon.svg';
import ChatbotIcon from '../images/chatbot-icon.svg';
import CashIcon from '../images/cash-icon.svg';
import Reward from '../images/reward.svg';
import RedTrapezium from '../images/red-trapezium.svg';
import { motion } from 'framer-motion';
import DurexRichMedia from '../components/DurexRichMedia';

const IndexPage = () => {

	const [open, setOpen] = React.useState(1);

	const handleOpen = (value) => setOpen(open === value ? 0 : value);

	const offerings = [
		{
			logo: DisplayIcon,
			heading: 'Digital Advertising Solutions',
			content: 'Experience the power of precision and efficiency with our diverse range of advertising formats.',
			link: ''
		},
		{
			logo: ChatIcon,
			heading: 'Messaging',
			link: '/products#messaging',
			content: ' Engage your offline audience through personalized and interactive messaging campaigns with our robust messaging platform.'
		},
		{
			logo: Reward,
			heading: 'Rewards System',
			content: 'With our rewards solution, design enticing loyalty programs and incentives that motivate customers to stay engaged with your brand.'
		},
		{
			logo: ChatbotIcon,
			heading: 'Chatbot',
			link: '/products#chatbot',
			content: 'Handle customer inquiries, provide instant assistance, and streamline interactions with our intelligent and conversational chatbot.'
		},
		{
			logo: CashIcon,
			heading: 'Monetization',
			content: 'At the heart of our platform lies a commitment to amplifying reveneu potential. ovative tools and strategies beyond convention.'
		},
	]

	const caseStudies = [
		{
			img: < StaticImage
				src="../images/peak-case.png"
				alt='dashboard'
				placeholder="blurred"
				quality="100"
				className='w-full lg:w-72 h-52 object-cover rounded-t-xl'
			/>,
			logo: <StaticImage
				src="../images/peak.png"
				alt='dashboard'
				placeholder="blurred"
				quality="100"
			/>,
			link: '/detailed-stories#peak',
			text: 'Using different interactive Rich media creatives, we increased Peak’s brand awareness by 95% leveraging all operating systems.'
		},
		{
			img: < StaticImage
				src="../images/bud-case.png"
				alt='dashboard'
				placeholder="blurred"
				quality="100"
				className='w-full lg:w-72 h-52 object-cover rounded-t-xl'
			/>,
			logo: <StaticImage
				src="../images/budweiser.png"
				alt='dashboard'
				placeholder="blurred"
				quality="100"
			/>,
			link: '/detailed-stories#budweiser',
			text: 'See how we successfully created an awareness campaign, reaching an impressive audience of 3.2 million users for the Budweiser Smooth King remix.'
		},
		{
			img: < StaticImage
				src="../images/flutterwave-case.png"
				alt='dashboard'
				placeholder="blurred"
				quality="100"
				className='w-full lg:w-72 h-52 object-cover rounded-t-xl'
			/>,
			logo: <StaticImage
				src="../images/flutterwave.png"
				alt='dashboard'
				placeholder="blurred"
				quality="100"
			/>,
			link: '/detailed-stories#flutterwave',
			text: 'We helped Flutterwave acquire 50,000 merchants for their platform across a few African countries.'
		},
	]

	const directPublishers = [
		<StaticImage
			src="../images/gads.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/meta.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/between.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/truecaller.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>, <StaticImage
			src="../images/scooper.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/spiral-logo.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>, <StaticImage
			src="../images/transsion.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,

	]

	const verificationTools = [
		<StaticImage
			src="../images/ganalytics.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/apps-flyer.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/clear-trust.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/the-media-trust.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
	]

	const clientele = [
		<StaticImage
			src="../images/peak.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/budweiser.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/uba.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/fcmb.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/schartered.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/dettol.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/bet9ja.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/branch.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/viablex.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/fxtm.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/union.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/heineken.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/tecno.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/itel.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
		<StaticImage
			src="../images/infinix.png"
			alt='dashboard'
			placeholder="blurred"
			quality="50"
		/>,
	]

	const brag = [
		{
			text: 'App Installations',
			top: <StaticImage
				src="../images/download-mockup.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/thumbs-up.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#00C28B]'
		},
		{
			text: 'Brand Awareness',
			top: <StaticImage
				src="../images/megaphone.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/marketing-laptop.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#FFAC45]'
		},
		{
			text: 'Video Advertising',
			top: <StaticImage
				src="../images/man-taking-picture.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/fast-forward.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#A3ACBC]'
		},
		{
			text: 'Performance Advertising',
			top: <StaticImage
				src="../images/dashboard-cutout.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/trending-up.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#068DD8]'
		},
		{
			text: 'App Installations',
			top: <StaticImage
				src="../images/download-mockup.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/thumbs-up.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#00C28B]'
		},
		{
			text: 'Brand Awareness',
			top: <StaticImage
				src="../images/megaphone.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/marketing-laptop.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#FFAC45]'
		},
		{
			text: 'Video Advertising',
			top: <StaticImage
				src="../images/man-taking-picture.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/fast-forward.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#A3ACBC]'
		},
		{
			text: 'Performance Advertising',
			top: <StaticImage
				src="../images/dashboard-cutout.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bottom: <StaticImage
				src="../images/trending-up.png"
				alt='dashboard'
				placeholder="blurred"
				quality="50"
			/>,
			bg: 'bg-[#068DD8]'
		},
	]

	return (
		<Layout pageTitle='Home - Dochase Adx' >
			<motion.div
				initial={{ opacity: 0, scale: 0.5 }}
				animate={{ opacity: 1, scale: 1 }}
				transition={{
					duration: 0.8,
					delay: 0.5,
					ease: [0, 0.71, 0.2, 1.01],
				}}
				className='pt-12 lg:pt-24 overflow-x-hidden'>

				<section className='max-w-[1440px] overflow-x-hidden mx-auto'>
					<div className='lg:mt-12 mx-[6%] lg:grid lg:grid-cols-2'>
						<div className='mt-12 lg:mt-6'>
							<p className='text-4xl lg:text-7xl font-bold text-[#454444] text-center lg:text-left'>Attract & <span className='text-brand-red'>Retain</span> Customers at Scale</p>
							<p className='mt-4 lg:mt-8 text-base lg:text-xl lg:mr-[15%] text-[#1E1E1E]  text-center lg:text-left'>We help agencies and Businesses to deliver cutting-edge digital advertising campaigns. Our expertise ensures you reach the perfect audience with captivating rich media elements and laser-focused targeting.</p>
							<div className='mt-6 lg:mt-12 space-x-6'>
								<Link to='/#form'>
									<motion.button
										whileHover={{ scale: 1.1 }}
										transition={{ type: "spring", stiffness: 400, damping: 10 }}
										className='bg-brand-red text-white py-3 px-11 rounded-md font-bold text-xs lg:text-base flex mx-auto lg:mx-0 w-max'>Contact Us</motion.button>
								</Link>
								{/* <a href='https://dashboard.dochaseadx.com/' target='_blank'>
										<button className='border border-brand-red text-brand-red py-3 px-14 rounded-md font-bold text-xs lg:text-base'>Login</button>
									</a> */}
							</div>
						</div>

						<div className='mt-8 lg:mt-0'>
							<StaticImage
								src="../images/dashboard-vector.png"
								alt='dashboard'
								placeholder="blurred"
								quality="100"
							/>
						</div>
					</div>
					<div className='mt-7 mx-[6%]'>
						<p className='text-[#7C7C7C] text-base lg:text-xl font-medium tracking-wider text-center lg:text-left '>Join over 1,000 brands worldwide</p>
						<div className='flex space-x-3 mt-1 justify-center lg:justify-start'>
							<StaticImage
								src="../images/mtn.png"
								alt='dashboard'
								placeholder="blurred"
								quality="100"
								className='h-7 lg:h-14'
							/>
							<StaticImage
								src="../images/peak.png"
								alt='dashboard'
								placeholder="blurred"
								quality="100"
								className='h-8 lg:h-14'
							/>
							<StaticImage
								src="../images/itel.png"
								alt='dashboard'
								placeholder="blurred"
								quality="100"
								className='h-7 lg:h-10 my-auto'
							/>
							<StaticImage
								src="../images/flutterwave.png"
								alt='dashboard'
								placeholder="blurred"
								quality="100"
								className='h-5 lg:h-10 my-auto'
							/>
							<StaticImage
								src="../images/uba.png"
								alt='dashboard'
								placeholder="blurred"
								quality="100"
								className='h-5 lg:h-14 my-auto'
							/>
						</div>
					</div>
				</section>

				{/* Next Part */}
				<section className='mt-12 lg:mt-24 flex img-ticker w-max max-h-[180px] lg:max-h-[510px]'>
					{brag.map((item, itemId) => (
						<div className='relative w-[300px] lg:w-[1000px] h-max flex justify-center mx-2 lg:mx-4' key={itemId}>
							<div className={`${item.bg} w-full rounded-lg`}>
								<div className='bg-noise w-full py-12 lg:py-36'>
									<div className='h-16 w-[25%] lg:h-56 absolute top-0 left-0'>
										{item.top}
									</div>
									<div className='w-[25%] lg:w-max absolute bottom-0 right-0'>
										{item.bottom}
									</div>
									<div className='grid w-full z-20'>
										<span className='mx-auto text-[12px] lg:text-[36px] font-bold'>Drive</span>
										<span className='mx-auto text-[20px] lg:text-[73px] text-white font-black z-10'>{item.text}</span>
										<span className='mx-auto text-[12px] lg:text-[36px] font-bold'>with Dochase</span>
									</div>
								</div>
							</div>
						</div>
					))}

					<div className='relative w-[300px] lg:w-[1000px] h-max flex justify-center mx-4'>
						<div className={`${brag[0].bg} w-full rounded-lg`}>
							<div className='bg-noise w-full py-12 lg:py-36'>
								{brag[0].top}
								{brag[0].bottom}
								<div className='grid w-full'>
									<span className='mx-auto text-[12px] lg:text-[36px] font-bold'>Drive</span>
									<span className='mx-auto text-[20px] lg:text-[73px] text-white font-black'>{brag[0].text}</span>
									<span className='mx-auto text-[12px] lg:text-[36px] font-bold'>with Dochase</span>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Next Part */}
				<section className='max-w-[1440px] overflow-x-hidden mx-auto mt-12 lg:mt-24'>
					<div
						className='mx-[6%] lg:mx-[12%]'>
						<p className='text-center text-2xl lg:text-4xl font-bold'>AD Operations</p>
						{/* <p className='mt-2 text-center text-base lg:text-xl'>Let us handle your next campaign</p> */}
						<div className="w-full hidden lg:flex space-x-8 mt-10">
							<div className="-ml-3 space-y-9">
								<Accordion open={open === 1}>
									<AccordionHeader onClick={() => handleOpen(1)} className="flex justify-start">
										<div className='bg-[#068dd81a] w-16 h-16 p-3 flex justify-center rounded-full'>
											<img src={Plan} alt="plan" className='' loadiing='lazy' />
										</div>
										<span className='text-4xl font-bold text-[#454444] ml-6'>Plan</span>
										{open !== 1 && <TbPlus className='text-brand-red w-6 h-6 my-auto' />}
										{open === 1 && <TbMinus className='text-brand-red w-6 h-6 my-auto' />}
									</AccordionHeader>
									<AccordionBody className={`ml-16 mt-6 text-xl text-[#4F4F4F] ${open !== 1 && 'hidden'} ${open === 1 && 'pb-11'} w-auto`}>
										Plan your 360 Digital Advertising campaigns with accurate data of your audience, platforms and deliverables.
									</AccordionBody>
								</Accordion>
								<Accordion open={open === 2}>
									<AccordionHeader onClick={() => handleOpen(2)} className="flex justify-start">
										<div className='bg-[#ffac451a] rounded-full w-16 h-16 flex justify-center'>
											<img src={Deploy} alt="Deploy" className='' loadiing='lazy' />
										</div>
										<span className='text-4xl font-bold text-[#454444] ml-6'>Deploy</span>
										{open !== 2 && <TbPlus className='text-brand-red w-6 h-6 my-auto' />}
										{open === 2 && <TbMinus className='text-brand-red w-6 h-6 my-auto' />}
									</AccordionHeader>
									<AccordionBody className={`ml-16 mt-6 text-xl text-[#4F4F4F] ${open !== 2 && 'hidden'} ${open === 2 && 'pb-11'} w-auto`}>
										Activate Digital Advertising campaigns on unified platforms - programmatic ads, social media, video ads, messaging and more.
										<br/>
										Leverage our advanced targeting tools to place your ads in front of high-performing audiences. Reach the right customers, in the right places, at the right time.
									</AccordionBody>
								</Accordion>
								<Accordion open={open === 3}>
									<AccordionHeader onClick={() => handleOpen(3)} className="flex justify-start">
										<div className='bg-[#00c28b1a] p-1 rounded-full  w-16 h-16 flex justify-center'>
											<img src={Measure} alt="Measure" className='' loadiing='lazy' />
										</div>
										<span className='text-4xl font-bold text-[#454444] ml-6'>Measure</span>
										{open !== 3 && <TbPlus className='text-brand-red w-6 h-6 my-auto' />}
										{open === 3 && <TbMinus className='text-brand-red w-6 h-6 my-auto' />}
									</AccordionHeader>
									<AccordionBody className={`ml-16 mt-6 text-xl text-[#4F4F4F] ${open !== 3 && 'hidden'} ${open === 3 && 'pb-11'} w-auto`}>
										Measure the reach, engagement and performance of your digital advertising campaigns.
									</AccordionBody>
								</Accordion>
							</div>
							{open === 1 ? <div className='bg-[#068dd80d] px-16 py-7 h-max rounded-[100px]'>
								<StaticImage
									src='../images/woman-writing-on-notes.png'
									alt='plan'
									placeholder="dominantColor"
									quality="100"
								/>
							</div> : open === 2 ? <div className='bg-[#ffac450d] px-16 py-7 h-max rounded-[100px]'>
								<StaticImage
									src="../images/social-media-emojis.png"
									alt='deploy'
									placeholder="dominantColor"
									quality="100"
								/>
							</div> : open === 3 ? <div className='bg-[#00c28b0d] pr-16 py-7 h-max rounded-[100px]'>
								<StaticImage
									src="../images/bar-chart.png"
									alt='measure'
									placeholder="dominantColor"
									quality="100"
								/>

							</div> : null}
						</div>

						<div className="w-full mt-10 lg:hidden">
							<div className="space-y-4">
								<div className=" flex flex-col ">
									<div className='bg-[#068dd81a] w-10 h-10 p-2 flex mx-auto rounded-full'>
										<img src={Plan} alt="plan" className='' loadiing='lazy' />
									</div>
									<span className='text-2xl font-bold text-[#454444] mt-5 ml-2 text-center'>Plan</span>
									<div className={`ml-2 text-base text-[#4F4F4F] pb-8 space-y-4 my-5 text-center`}>
										<p>Plan your 360 Digital Advertising campaigns with accurate data of your audience, platforms and deliverables.</p>
										<div className='bg-[#068dd80d] px-6 py-2 h-max rounded-[32px]'>
											<StaticImage
												src="../images/woman-writing-on-notes.png"
												alt='plan'
												placeholder="dominantColor"
												quality="100"
											/>
										</div>
									</div>
								</div>

								<div className="flex flex-col">
									<div className='bg-[#ffac451a] w-10 h-10 flex mx-auto rounded-full'>
										<img src={Deploy} alt="Deploy" className='' loadiing='lazy' />
									</div>
									<span className='text-2xl font-bold text-[#454444] ml-2 text-center mt-5'>Deploy</span>
									<div className={`ml-2 text-base text-[#4F4F4F] pb-8 space-y-4 my-5 text-center`}>
										<p>Activate Digital Advertising campaigns on unified platforms - programmatic ads, social media, video ads, messaging and more.
										<br/>
										Leverage our advanced targeting tools to place your ads in front of high-performing audiences. Reach the right customers, in the right places, at the right time.</p>
										<div className='bg-[#ffac450d] px-6 py-2 h-max rounded-[32px]'>
											<StaticImage
												src="../images/social-media-emojis.png"
												alt='deploy'
												placeholder="dominantColor"
												quality="100"
											/>
										</div>
									</div>
								</div>

								<div className="flex flex-col">
									<div className='bg-[#00c28b1a] w-10 h-10 flex mx-auto rounded-full'>
										<img src={Measure} alt="Measure" className='' loadiing='lazy' />
									</div>
									<span className='text-2xl font-bold text-[#454444] ml-2 text-center mt-5'>Measure</span>
									<div className={`ml-2 text-base text-[#4F4F4F] pb-8 space-y-4 my-5 text-center`}>
										<p>Measure the reach, engagement and performance of your digital advertising campaigns.</p>
										<div className='bg-[#00c28b0d] pr-6 py-2 h-max rounded-[32px]'>
											<StaticImage
												src="../images/bar-chart.png"
												alt='measure'
												placeholder="dominantColor"
												quality="100"
											/>

										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</section>

				{/* Next Part */}
				<section className='lg:max-w-[1440px] mx-auto py-16 lg:py-32'>
					<div className='mx-[6%] lg:mx-0 lg:ml-[12%] mr-[2.5%] lg:mr-[5%]'>
						<div className='lg:grid lg:grid-cols-2 lg:space-x-9 space-y-4 lg:space-y-0'>
							<div className='mt-7 lg:mt-14'>
								<p className='text-2xl lg:text-5xl font-bold text-center lg:text-left'>Rich Media</p>
								<p className='text-[#4F4F4F] text-base lg:text-xl mt-4 lg:mt-9 text-center lg:text-left'>With Rich Media Ads, you can capture the attention of potential and existing customers by prompting them to interact with the ad and provide a <span className='font-medium'>more engaging experience.</span></p>
								<Link className={`hidden lg:flex mt-16 space-x-4 w-max p-2 px-6 rounded-2xl duration-700`}>
									<div className='my-auto'>
										<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
											<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z"
												fill='#1F1F1F' />
										</svg>
									</div>
									<p className='text-lg font-bold my-auto'>Learn more about this service</p>
								</Link>
							</div>
							<DurexRichMedia />
						</div>
						<Link className='lg:hidden flex space-x-4 mt-8 justify-center'>
							<div className='my-auto'>
								<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
									<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z" fill="#1F1F1F" />
								</svg>
							</div>
							<p className='text-lg font-bold my-auto'>Learn more about this service</p>
						</Link>
					</div>
				</section>

				{/* Next Part */}
				<div className='bg-[#f9253908] mt-10 lg:mt-20'>
					<section className='max-w-[1440px] mx-auto py-10 lg:py-20'>
						<div className='mx-[6%] lg:mx-[12%]'>
							<div className='lg:flex justify-between mt-12 lg:mt-24'>
								<div className='my-auto'>
									<p className='text-2xl lg:text-5xl font-bold text-[#454444] text-center lg:text-left'>Customer Acquisition</p>
									<p className='my-6 lg:my-12 text-[#4F4F4F] text-base lg:text-xl text-center lg:text-left'>We're not just in the business of running ads; we're in the business of driving concrete results that matter.</p>
									<Link to='/solutions#customer-acquisition' className={`hidden lg:flex space-x-4 duration-700 w-max p-2 px-6 rounded-2xl`}>
										<div className='my-auto'>
											<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
												<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z"
													fill='#1F1F1F'
												/>
											</svg>
										</div>
										<p className='text-lg font-bold my-auto'>Learn more about this service</p>
									</Link>
								</div>
								<StaticImage
									src="../images/man-folding-arms.png"
									alt='approach'
									className='lg:w-4/5 object-cover'
									placeholder="blurred"
									quality="100"
								/>
							</div>
							<Link to='/solutions#customer-acquisition' className='lg:hidden flex space-x-4 justify-center'>
								<div className='my-auto'>
									<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
										<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z" fill="#1F1F1F" />
									</svg>
								</div>
								<p className='text-lg font-bold my-auto'>Learn more about this service</p>
							</Link>
						</div>
					</section>

					{/* Next Part */}
					<section className=' py-20 lg:py-40 w-full bg-white' >
						<div className='lg:max-w-[1440px] mx-auto'>
							<div className='mx-[6%] lg:mx-[12%] pt-4 lg:pt-8 '>
								<div className='grid lg:grid-cols-2'>
									<div className='order-last lg:order-first h-max'>
										<StaticImage
											src='../images/holding-phone.png'
											alt='approach'
											className='object-cover mx-auto'
											placeholder="blurred"
											quality="100"
										/>
									</div>
									<div className='my-auto lg:text-right grid lg:justify-items-end'>
										<p className='text-2xl lg:text-5xl font-bold text-[#454444] text-center lg:text-left'>Retargeting</p>
										<p className='mt-5 lg:mt-6 text-base lg:text-xl text-center lg:text-right'>Re-engage potential customers who've shown interest in your brand. Whether it's reminding them of abandoned carts, offering personalized recommendations, or enticing them back to explore further.
										</p>
										<Link to={`${routes.solutions.path}#retargeting`} className={`hidden lg:flex space-x-4 mt-16 w-max p-2 px-6 rounded-2xl duration-700`}>
											<div className='my-auto'>
												<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
													<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z"
														fill="#1F1F1F" />
												</svg>
											</div>
											<p className='text-lg font-bold my-auto'>Learn more about this service</p>
										</Link>
									</div>
								</div>
								<Link to={`${routes.solutions.path}#retargeting`} className='lg:hidden flex space-x-4 justify-center mt-8'>
									<div className='my-auto'>
										<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
											<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z" fill="#1F1F1F" />
										</svg>
									</div>
									<p className='text-lg font-bold my-auto'>Learn more about this service</p>
								</Link>
							</div>
						</div>
					</section>


					{/* Next Part */}
					<section className='w-full pt-16 lg:pt-32 pb-12 bg-white'>
						<div className='lg:max-w-[1440px] mx-auto'>
							<div className='mx-[6%] lg:mx-[12%]'>
								<div className='grid lg:grid-cols-2'>
									<StaticImage
										src="../images/messaging.png"
										alt='messaging'
										className='object-cover order-2 lg:order-first'
										placeholder="blurred"
										quality="100"
									/>
									<div className='lg:mt-[15%] lg:text-right items-end flex flex-col'>
										<p className='text-2xl lg:text-5xl font-bold text-center lg:text-right'>Messaging</p>
										<p className='text-[#4F4F4F] mt-4 text-base lg:text-xl lg:mt-9 text-center lg:text-right'>Through bold formatting, striking fonts, and vivid colours, your messages become visual narratives that capture attention. With Rich text, you go beyond plain text by incorporating multimedia elements to drive engagement.</p>
										<Link to='/products#messaging' className={`hidden lg:flex space-x-4 justify-end mt-16 w-max p-2 px-6 rounded-2xl duration-700`}>
											<div className='my-auto'>
												<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
													<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z"
														fill='#1F1F1F'/>
												</svg>
											</div>
											<p className='text-lg font-bold my-auto'>Learn more about this service</p>
										</Link>
									</div>
								</div>
								<Link to='/products#messaging' className='w-full lg:hidden flex space-x-4 justify-center mt-8'>
									<div className='my-auto'>
										<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none">
											<path d="M25.2948 11.9543L18.8857 5.51607C18.7118 5.35296 18.627 5.14016 18.6313 4.87764C18.6356 4.61513 18.7221 4.39691 18.8906 4.22299C19.0894 4.03825 19.3195 3.94588 19.5809 3.94588C19.8423 3.94588 20.0573 4.04527 20.2258 4.24406L28.043 12.045C28.2904 12.2729 28.4141 12.5457 28.4141 12.8633C28.4141 13.1809 28.2904 13.4634 28.043 13.7108L20.208 21.5458C20.0254 21.7283 19.8056 21.8202 19.5485 21.8213C19.2914 21.8223 19.0634 21.7305 18.8646 21.5458C18.6853 21.3611 18.5957 21.1407 18.5957 20.8847C18.5957 20.6286 18.6853 20.4109 18.8646 20.2316L25.2948 13.8016H8.37214C6.13696 13.8016 4.26613 13.0475 2.75965 11.5394C1.25314 10.0313 0.499882 8.16125 0.499882 5.92931V1.17164C0.499882 0.896151 0.587391 0.670912 0.762409 0.495922C0.937399 0.320906 1.15292 0.233395 1.40897 0.233395C1.68443 0.233395 1.90967 0.320906 2.08469 0.495922C2.25968 0.670912 2.34717 0.896151 2.34717 1.17164V5.92931C2.34717 7.64701 2.92191 9.08059 4.0714 10.23C5.22085 11.3795 6.65443 11.9543 8.37214 11.9543H25.2948Z" fill="#1F1F1F" />
										</svg>
									</div>
									<p className='text-lg font-bold my-auto'>Learn more about this service</p>
								</Link>
							</div>
						</div>
					</section>
				</div>


				{/* Next Part */}
				<section className='mt-16 lg:mt-32'>
					<div className='lg:max-w-[1440px] mx-auto'>
						<div className='ml-[3%] lg:ml-[6%] pt-3 lg:pt-6'>
							<p className='text-[#454444] text-xl lg:text-[40px] font-bold tracking-tight leading-6 lg:leading-[48px] text-center'>Explore new avenues of growth, engagement,<br />
								and success that were once beyond reach.</p>
						</div>
					</div>
				</section>
				<div className='bg-brand-red mt-8 relative hidden lg:block h-[400px]'>
					<div className='w-full absolute top-12 left-0'>
						<div className='pl-[2%] mx-auto max-w-[1440px]'>
							<div className='w-full flex justify-end'>
								<div className='mr-12 -mt-4' id='swiper-forward'><TbArrowRight className='text-white w-7 h-7' /></div>
							</div>
							<Swiper
								slidesPerView={3.5}
								spaceBetween={20}
								navigation={{ nextEl: '#swiper-forward' }}
								mousewheel={true}
								modules={[Navigation, Mousewheel]}
								rewind={true}
								className=""
							>
								{offerings.map((item, itemId) => (
									<SwiperSlide key={itemId}>
										<Link to={item.link} >
											<div className='transition duration-300 ease-in-out transform hover:scale-105'>
												<div className='bg-white rounded-xl px-9 pt-11 pb-6 h-72 relative '>
													<img src={item.logo} alt="Digital advertising solutions" loading='lazy' />
													<p className='text-[#454444] text-xl font-bold mt-5'>{item.heading}</p>
													<p className='text-[#4F4F4F] text-base mt-5'>{item.content}</p>
													<div className='w-full flex justify-end items-end absolute bottom-4 right-6'>
														<Link to={item.link}><button className='flex text-brand-red text-sm font-bold'>Learn more <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button></Link>
													</div>
												</div>
											</div>
										</Link>
									</SwiperSlide>
								))}
							</Swiper>
						</div>
					</div>
				</div>

				{/* Mobile */}
				<div className='lg:hidden pl-[2%] mx-auto mt-8 w-10/12'>
					<div className='w-full flex justify-end'>
						<div className='mr-12 mt-4' id='swiper-forward'><TbArrowRight className='text-brand-red w-7 h-7' /></div>
					</div>
					<Swiper
						slidesPerView={1.2}
						spaceBetween={20}
						navigation={{ nextEl: '#swiper-forward' }}
						modules={[Navigation]}
						rewind={true}
						className=""
					>
						{offerings.map((item, itemId) => (
							<SwiperSlide key={itemId}>
								<div className='bg-white px-9 pt-11 pb-6 h-80 relative border rounded-xl shadow-xl mb-4'>
									<img src={item.logo} alt="Digital advertising solutions" loadiing='lazy' />
									<p className='text-[#454444] text-xl font-bold mt-5'>{item.heading}</p>
									<p className='text-[#4F4F4F] text-sm mt-5'>{item.content}</p>
									<div className='w-full flex justify-end items-end absolute bottom-4 '>
										<button className='flex text-brand-red text-sm font-bold'>Learn more <TbChevronRight className='w-3 h-3 my-auto ml-2' /></button>
									</div>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
				</div>

				{/* Next Part */}
				<section className='max-w-[1440px] mt-20 lg:mt-40 mx-auto'>
					<div className='lg:grid grid-cols-3 mr-[5%]'>
						<div className='relative h-auto'>
							<img src={RedTrapezium} alt='Case' className='h-full' loadiing='lazy' />
							<p className='absolute inset-y-1/2 right-1/3 text-white text-xl lg:text-3xl font-bold text-center h-max w-max'>Case Studies</p>
						</div>
						<p className='col-span-2 text-base lg:text-3xl xl:text-4xl lg:basis-2/3 lg:text-right ml-[5%] lg:ml-0 mt-4 lg:mt-0'>We always deliver on our goals which is why we are trusted by several brands across different sectors to deliver on their business needs.</p>
					</div>
					<div className='lg:max-w-[1440px] mx-auto'>
						<div className='lg:flex lg:space-x-16 mt-4 lg:mt-24 lg:space-y-0 lg:justify-center mx-[5%] lg:mx-0'>
							{caseStudies.map((item, itemId) => (
								<Link to={item.link}>
									<div className='lg:w-72 mt-8 lg:mt-0 transition duration-300 ease-in-out transform rounded-b-2xl  hover:scale-105' id='card' key={itemId}>
										{item.img}
										<div className='text-center relative pt-4 pb-12 h-64'>
											{item.logo}
											<p className='mt-2 px-8 text-[#4F4F4F] text-base'>{item.text}</p>
											<Link to={item.link} className='flex text-brand-red text-xs font-bold mx-auto absolute bottom-4 left-[40%]'>Read Story <TbChevronRight className='w-3 h-3 my-auto ml-2' /></Link>
										</div>
									</div>
								</Link>
							))}

						</div>
					</div>
				</section>

				{/* Next Part */}
				<section className='mt-12 lg:mt-24 lg:max-w-[1440px] mx-auto'>
					<p className='text-center text-[#BFBFBF] text-2xl lg:text-4xl font-bold'>Partnerships <span className='text-[#373636] font-medium'>&</span> Integrations</p>
					<div className='lg:flex lg:space-x-6 mx-[6%] mt-10'>
						<div className='rounded-xl h-[526px] lg:w-[409px]' id='card'>
							<div className='bg-[#068DD81A] bg-opacity-10 rounded-full w-[72px] h-[72px] mx-auto mt-8'>
								{/* <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331942/dochaseadx/om9auwprtwvexbaacksb.svg' alt='direct' className='mx-auto pt-4' loadiing='lazy' /> */}
							</div>
							<p className='text-center text-xl lg:text-3xl font-bold text-[#454444]'>Ad Networks and Direct Publishers</p>
							<div className='grid grid-cols-2 gap-4 mt-7'>
								{directPublishers.map((item, itemId) => (
									<div key={itemId} className='mx-auto my-auto'>
										{item}
									</div>
								))}
							</div>
						</div>

						<div className='rounded-xl h-[526px] lg:w-[409px]' id='middle-card'>
							<div className='bg-[#068DD81A] bg-opacity-10 rounded-full w-[72px] h-[72px] mx-auto mt-8'>
								{/* <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331759/dochaseadx/e27gqzuwmhiikdqf2z57.svg' alt='verification' className='mx-auto pt-4' loadiing='lazy' /> */}
							</div>
							<p className='text-center text-xl lg:text-3xl font-bold text-[#454444]'>Verification and Mobile Attribution Tools</p>
							<div className='grid grid-cols-2 mt-7'>
								{verificationTools.map((item, itemId) => (
									<div key={itemId} className='mx-auto my-auto'>
										{item}
									</div>))}
							</div>
						</div>

						<div className='rounded-xl h-[526px] lg:w-[409px]' id='card'>
							<div className='bg-[#068DD81A] bg-opacity-10 rounded-full w-[72px] h-[72px] mx-auto mt-8'>
								{/* <img src='https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331913/dochaseadx/y3cxebb3vz0bzq6yk55u.svg' alt='clientele' className='mx-auto pt-4' loadiing='lazy' /> */}
							</div>
							<p className='text-center text-xl lg:text-3xl font-bold text-[#454444]'>Clientele</p>
							<div className='grid grid-cols-3 gap-4 mt-7'>
								{clientele.map((item, itemId) => (
									<div key={itemId} className='mx-auto my-auto'>
										{item}
									</div>))}
							</div>
						</div>
					</div>
				</section>

				{/* Next Part */}
				<div id='form'>
					<ContactForm />
				</div>
			</motion.div>
		</Layout >
	)
}

export default IndexPage
